import React from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Button, Dropdown, Menu, Space } from "antd";
import { ToolOutlined, DownOutlined } from "@ant-design/icons";
import ProjectDetailsCard from "./ProjectDetailsCard";
import CollapsibleTable from "./CollapsibleTable";

export default function Result() {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location || {};
  const { projectName, owners, teamMembers, description } = state || {};

  const handleMenuClick = ({ key }) => {
    if (key === "fragmentation") {
      navigate(`/${projectId}/fragmentation`, { state: location.state });
    }
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="fragmentation">
        Fragmentation
      </Menu.Item>
    </Menu>
  );

  const toolsDropdown = (
    <Dropdown overlay={menu}>
        <Button type="primary">
            <Space>
                <ToolOutlined />
                Tools
                <DownOutlined />
            </Space>
        </Button>
    </Dropdown>
  );

  return (
    <>
      <ProjectDetailsCard 
        projectName={projectName} 
        owners={owners} 
        teamMembers={teamMembers} 
        description={description} 
      />
      <CollapsibleTable
        projectId={projectId}
        projectName={projectName}
        owners={owners}
        teamMembers={teamMembers}
        description={description}
        extraControls={toolsDropdown}
      />
    </>
  );
}
